import axios from 'axios'

export default {
  getLegalDocuments: () => axios.get(`/legal_documents?outdated=true`),
  getOnboardingLegalDocuments: id => axios.get(`/legal_documents/invitation/${id}`),
  acceptTerms: (id, transactionInformation) =>
    axios.put(`/users/${id}/accept_tos`, transactionInformation)
}
